import { onBeforeUnmount, onMounted } from 'vue';
import useSequence from '@/composables/useSequence';
import useContent from '@/composables/useContent';
import ChatbotService from '@/js/chatbot';
import Say from '@/actions/say';

export default function useChatbot() {
  let chatbotSayAction;
  let repromptSeqItems;
  const { restartSequence, currentSeq } = useSequence();
  const { currentContent } = useContent();

  async function askChatbot(text) {
    const chatbotService = new ChatbotService();
    const message = await chatbotService.sendRequest(text);

    chatbotSayAction = new Say({ utterance: message });
    await chatbotSayAction.execute();
    chatbotSayAction = null;

    restartSequence(false, repromptSeqItems);
  }

  onMounted(() => {
    if (!currentContent.value.attrs.useReprompt) {
      repromptSeqItems = currentSeq.value.items.filter(({ params }) => !params.noReprompt);
    }
  });

  onBeforeUnmount(() => {
    if (chatbotSayAction) {
      chatbotSayAction.stop();
    }
  });

  return {
    askChatbot,
  };
}
